//IAmFlying.jsx
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFish, faPlus, faUserTie, faBarChart, faLineChart } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import Loader from "../../components/utils/Loader";
import Tooltip from "../../components/utils/Tooltip";

const IAmFlying = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const navigate = useNavigate();

  const [books, setBooks] = useState([]);
  const [bookId, setBookId] = useState([]);
  const [ownerId, setOwnerId] = useState([]);
  const [bookMasterId, setBookMasterId] = useState([]);

  const [readLogs, setReadLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState([]);

  const [bookTitle, setBookTitle] = useState("");
  const [selectedBookId, setSelectedBookId] = useState(null);

  const [selectedFlyerId, setSelectedFlyerId] = useState(null);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [postCommentClicked, setPostCommentClicked] = useState(false);
  const [postedComment, setPostedComment] = useState(false);
  const [postedCommentMsg, setPostedCommentMsg] = useState("");
  const [postMyCommentClicked, setPostMyCommentClicked] = useState(false);
  const [flyerOnTheWallListClick, setFlyerOnTheWallListClick] = useState(false);
  const [viewReadLogClicked, setViewReadLogClicked] = useState(false);
  const [expandedDates, setExpandedDates] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [bookPages, setBookPages] = useState(1);
  const [isChildren, setIsChildren] = useState(1);

  const [pageContent, setPageContent] = useState("");
  const [splText, setSplText] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [hasSpeech, setHasSpeech] = useState(0);
  const [hasMusic, setHasMusic] = useState(0);
  const [hasVideo, setHasVideo] = useState(0);
  const [videoUrl, setVideoUrl] = useState(0);
  const [isBase64Audio, setIsBase64Audio] = useState(0);
  const [base64Audio, setBase64Audio] = useState(false);
  const [readFromSplText, setReadFromSplText] = useState(0);
  // const [musicAudio] = useState(new Audio(backgroundMusic));
  const [pageCount, setPageCount] = useState(bookPages);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [dateRead, setDateRead] = useState(new Date());
  const [pageLoadTime, setPageLoadTime] = useState(null);
  const [readTimeInMiliseconds, setReadTimeInMiliseconds] = useState(0);
  const [readingRemarks, setReadingRemarks] = useState("");
  const [isLogSaved, setIsLogSaved] = useState(true);
  const [isInteracted, setIsInteracted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [userCommentTitle, setUserCommentTitle] = useState("");
  const [userCommentDetails, setUserCommentDetails] = useState("");
  const [elapsedTime, setElapsedTime] = useState(0);
  const [error, setError] = useState(false);
  const [commentListFetched, setCommentListFetched] = useState(false);
  const [commentData, setCommentData] = useState([]);
  const [errors, setErrors] = useState();
  const [userComment, setUserComment] = useState("");
  const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
  const [postToBeDisabled, setPostToBeDisabled] = useState(false);
  const [readCommentClicked, setReadCommentClicked] = useState(false);
  const [postCloseClicked, setPostCloseClicked] = useState(false);
  const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
  const [isImportantChecked, setIsImportantChecked] = useState(false);
  
  const [bookIdForComment, setBookIdForComment] = useState("");
  const [bookTitleForComment, setBookTitleForComment] = useState("");
  const [bookUserIdForComment, setBookUserIdForComment] = useState("");


  const fetchBooks = useCallback(() => {
    const config = {
      url: "/flyonwall/flyingbooks",
      method: "post",
      headers: { Authorization: authState.token },
      data: { flyerCode: authState.user.think5whyscode },
    };

    fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("received data : ", data);
        if (data && Array.isArray(data.flyingbooks)) {
          setBooks(data.flyingbooks);
        } else {
          console.error("Invalid response format: Books not found!");
        }
      })
      .catch((error) => {
        console.error("Error fetching Books As Flyer:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBooks();
  }, [authState.isLoggedIn, fetchBooks]);

  const [prevBookId, setPrevBookId] = useState("");
  const handleFlyerOnTheWallListClick = useCallback((bookId, ownerId) => {
    setPrevBookId(bookId);
    fetchReadingLog(bookId, ownerId);
    setSelectedBookId(bookId);
    setFlyerOnTheWallListClick(true);
  }, []);

  const sortedLog = readLogs.sort((a, b) => {
    const dateA = new Date(a.dateRead);
    const dateB = new Date(b.dateRead);
    return dateB - dateA;
  });

  const toggleDateExpansion = (date) => {
    if (expandedDates.includes(date)) {
      setExpandedDates(expandedDates.filter((item) => item !== date));
    } else {
      setExpandedDates([...expandedDates, date]);
    }
  };

  const logsByDate = readLogs.reduce((acc, log) => {
    const date = log.dateRead.split("T")[0];
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(log);
    return acc;
  }, {});

  const formatReadTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds}`;
  };

  const fetchReadingLog = async (bookId, ownerId) => {
    const config = {
      url: "/myreadinglog/logforflyer",
      method: "post",
      headers: { Authorization: authState.token },
      data: { bookId: bookId, userId: ownerId },
    };
    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        // consolse.log("fetchReadingLog response ", response);

        if (response && response.status) {
          setReadLogs(response.readingLogs);
          setSelectedLog(bookId);
        } else {
          console.error(
            "Invalid response format: Book reading log not found in response"
          );
        }
      })
      .catch((error) => {
        console.error("Retry to get the record", error);
      });
  };

  const handleViewReadLog = useCallback((bookId) => {
    setSelectedBookId(bookId);
    setViewReadLogClicked(true);
    setFlyerOnTheWallListClick(false);
    setShowResults(true);
  }, []);

  const [viewCommentClick, setViewCommentClick] = useState(false);
  const [viewCommentClickMsg, setViewCommentClickMsg] = useState("");
  const handleViewComments = (bookId, pageNumber, userId) => {
    setViewCommentClick(true);
    setViewCommentClickMsg(
      "You can view your annotations & other's comments for this page! We will get back to you soon with this feature."
    );
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const handleImportantCheckboxChange = (event) => {
    setIsImportantChecked(event.target.checked);
  };

  const handleVisibleToAllCheckboxChange = (event) => {
    setIsVisibleToAllChecked(event.target.checked);
  };

  const postComment = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    // console.log("I am inside postCooment()");
    setCurrentPageNumber(pageNumber);
    setBookIdForComment(bookIdForComment);
    setBookTitleForComment(bookTitleForComment);
    setBookUserIdForComment(userIdForComment);
    setUserCommentTitle("");
    setUserCommentDetails("");
    setIsImportantChecked(false);
    setIsVisibleToAllChecked(false);
    setErrors("");
    setPostedCommentMsg("");
    setPostCommentClicked(true);
    setPostCloseClicked(false);
    setPostToBeDisabled(false);
  };

  const handlePostComment = (
    commentTitle,
    commentDetails,
    isImportant,
    visibleToAll,
    selectedPageNumber,
    selectedBookId,
    selectedBookTitle, 
    selectedBookOwnerId
  ) => {
    setPostCommentClicked(true);
    setPostToBeDisabled(true);

    if (commentTitle == "") {
      setErrors("Comment title must not be blank");
      return;
    }
    if (commentDetails == "") {
      setErrors("Comment/details must not be blank");
      return;
    }
    postReadComment(
      commentTitle,
      commentDetails,
      isImportant,
      visibleToAll,
      selectedPageNumber,
      selectedBookId,
      selectedBookTitle,
      selectedBookOwnerId
    );
  };

  const postReadComment = useCallback(
    (
      commentTitle,
      commentDetails,
      isImportant,
      visibleToAll,
      selectedPageNumber,
      selectedBookId,
      selectedBookTitle,
      selectedBookOwnerId
    ) => {
      const config = {
        url: "/myreadingnotes",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
          userId: selectedBookOwnerId,
          bookId: selectedBookId,
          bookTitle: selectedBookTitle,
          pageNumber: selectedPageNumber,
          isImportant: isImportant,
          notesTitle: commentTitle,
          notesText: commentDetails,
          notesBy: authState.user.name,
          notesByCode: authState.user.think5whyscode,
          notesType: "TXT",
          visibleToAll: visibleToAll,
          teamCode: "",
          notesPictureData: "",
          isActive: true,
          isDeleted: false,
          dateCreated: new Date(),
          notesRemarks: "",
          creatorId: authState.user._id,
        },
      };
      fetchData(config, { showSuccessToast: false })
        .then((response) => {
          if (response && response.status) {
            setPostedComment(true);
            setPostedCommentMsg("Comment Posted");
          } else {
            console.error("BookRead comments data posting error");
            setPostedCommentMsg("Error in Posting Your Comment. Please Retry.");
          }
        })
        .catch((error) => {
          console.error("Error in Posting Your Comment:", error);
        });
    },
    [authState.token, setPostedComment, setPostedCommentMsg]
  );

  const readComment = (selectedBookId, bookOwnerId, bookPageNumber) => {
    setReadCommentClicked(true);
    fetchReadCommentByPageNumber(selectedBookId, bookOwnerId, bookPageNumber);
    setReadCommentCloseClicked(false);
  };

  const fetchReadCommentByPageNumber = useCallback((selectedBookId, bookOwnerId, bookPageNumber) => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: selectedBookId,
        userId: bookOwnerId,
        pageNumber: bookPageNumber
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.status) {
          setCommentData(response.notes);
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData].sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(false);
    setPostToBeDisabled(true);
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const gotoRCA = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    navigate("/rcas/add");
  };

  const formatDateTime = (date) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, "0");
    const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, "0");
    const minutes = jsDate.getMinutes().toString().padStart(2, "0");
    const seconds = jsDate.getSeconds().toString().padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, "0");
    const month = (jsDate.getMonth() + 1).toString().padStart(2, "0");
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleViewGraphTimeLineClick = (graphData) => {
    navigate("/bigdata-book-readlog-timeline", { state: { graphData: graphData } });
  };

  const handleReaderSelection = (event) => {
    setSelectedReader(event.target.value);
    setShowDropdown(true); 
  };

  const [selectedReader, setSelectedReader] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const uniqueReaders = [...new Set(readLogs.map((log) => log.readerName))];

  const handleSelectStudent = () => {
    setShowDropdown(true);
  }

const logsByDateForOne = readLogs
  .filter((log) => log.readerName === selectedReader) 
  .reduce((acc, log) => {
    const date = log.dateRead.split("T")[0]; 
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(log);
    return acc;
  }, {});

const handleViewGraphTimeLineClickByStudent = (graphData) => {
  navigate("/bigdata-book-readlog-timeline", { state: { graphData: graphData, selectedReader: selectedReader } });
};


  return (
    <div className="min-h-screen bg-black text-white [&_p]:text-white py-2">
      <div className='border-b border-blue-400 mb-2'>
        <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
          📖 I Am Flying On The Wall
        </h2>
      </div>
      <div className="min-h-[85vh] my-2 mx-auto py-2">
        <div className="p-4 mt-2">
          <div className="flex justify-between items-center">
            <p className="text-yellow-300">There are <strong>{books.length}</strong> Books I am Flying On The Wall for </p>
            {bookTitle !== "All" && (
              <p className="text-xl mt-1 text-white">{bookTitle} </p>
            )}
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {books.length === 0 ? (
                <div className="flex items-center justify-center text-yellow-300">
                  <span>No record found!!</span>
                </div>
              ) : (
                books.map((book, index) => (
                  <div
                    key={book._id}
                    className="bg-black border border-gray-500 my-1 p-4 text-white rounded-md shadow-md"
                  >
                    <div className="flex flex-row justify-between">
                      <div>
                        <span className="font-medium">
                          {index + 1}.{book.bookTitle}
                          {" of "}
                          {book.ownerName}
                        </span>
                      </div>
                      <div>
                      <Tooltip text={"View Reading Log"} position={"top"}>
                        <span
                          className="ml-auto mr-4 text-blue-500 cursor-pointer"
                          onClick={() => handleViewReadLog(book._id)}
                        >
                          <i className="fa-solid fa-book-open"></i>
                        </span>
                      </Tooltip>
                      </div>
                    </div>
                    {selectedBookId === book._id && (
                      <>
                        <div className="bg-black py-2 text-white">
                          <p><strong>Book Owner:</strong> {book.ownerName}</p>
                        </div>
                        {selectedBookId === book._id && (
                          <>
                            <div>
                              <button
                                className="w-full mt-2 p-2 text-white rounded bg-purple-800"
                                disabled={
                                  flyerOnTheWallListClick &&
                                  selectedBookId === book._id
                                }
                                onClick={() =>
                                  handleFlyerOnTheWallListClick(
                                    book.bookId,
                                    book.ownerId
                                  )
                                }
                              >
                               <span className="text-sm lg:text-lg"> Click to View {book.bookTitle} Read Log </span>
                                {/* of{" "}{book.ownerName} */}
                              </button>
                            </div>
                            {selectedBookId === book._id &&
                              readLogs.length === 0 && (
                                <div className="flex flex-row justify-center text-sm lg:text-lg text-yellow-200 mt-2 mb-2">
                                  As per the record, The Book {book.bookTitle}{" "} has not been read!
                                   {/* by {book.ownerName} yet!! */}
                                </div>
                              )}
                            {selectedBookId === book._id &&
                              readLogs.length > 0 && (
                                <>
                                  <p className="p-2 text-sm lg:text-m">
                                      {book.bookTitle} has been read{" "}
                                      <span className="text-yellow-200">
                                        {readLogs.length}
                                      </span>{" "}
                                      times!
                                  </p>
                                  <div className="flex flex-row gap-2 mt-2 mb-2">
                                    <button
                                      className="w-40 lg:w-80 py-1 text-sm lg:text-m text-white rounded bg-green-500"
                                      onClick={() => handleViewGraphTimeLineClick(logsByDate)}
                                    >
                                      <FontAwesomeIcon icon={faBarChart} />View Graph - All
                                    </button>
                                    {/* <span className="tooltip">View Graph - All</span> */}
                                    <button
                                      className="w-40 lg:w-80 py-1 text-sm lg:text-m text-white rounded bg-green-500"
                                      onClick={() => handleSelectStudent(readLogs)}
                                    >
                                      Select One
                                    </button>                                    
                                  </div>
                                  <div className="flex flex-row items-center space-x-2">
                                    {/* <button
                                      className="py-2 px-4 text-white rounded bg-green-500"
                                      onClick={() => handleSelectStudent(readLogs)}
                                      style={{ maxWidth: "160px" }}
                                    >
                                      Select One
                                    </button> */}
                                    {showDropdown && (
                                      <div className="flex flex-row items-center space-x-2">
                                        <select
                                          className="py-2 px-4 h-10 border rounded text-black"
                                          value={selectedReader}
                                          onChange={handleReaderSelection}
                                        >
                                          <option value="">Select Reader</option>
                                          {uniqueReaders.map((reader) => (
                                            <option key={reader} value={reader}>
                                              {reader}
                                            </option>
                                          ))}
                                        </select>

                                        <button
                                          className="py-2 px-4 text-white rounded bg-green-500 flex items-center"
                                          onClick={() => handleViewGraphTimeLineClickByStudent(logsByDateForOne)}
                                        >
                                          <FontAwesomeIcon icon={faLineChart} className="mr-2" />
                                          View Graph of {selectedReader}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  <div>
                                    <p className="text-sm mb-1 mt-1">Time Spent in min:sec</p>
                                  </div>
                                  <div className="flex w-full text-sm text-white bg-slate-700">
                                    <div className="flex-[25%] border border-white text-left p-1">Date Read</div>
                                    <div className="flex-[30%] border border-white p-1">Page#</div>
                                    <div className="flex-[18%] border border-white p-1">Reader</div>
                                    <div className="flex-[12%] border border-white p-1">Time Spent</div>
                                    <div className="flex-[10%] border border-white p-1">Notes</div>
                                    <div className="flex-[5%] border border-white p-1">RCA</div>
                                  </div>

                                  <div className="text-white bg-black w-full text-sm">
                                    {Object.entries(logsByDate).map(
                                      ([date, logs]) => (
                                        <div key={date}>
                                          <div
                                            onClick={() =>
                                              toggleDateExpansion(date)
                                            }
                                            style={{ textAlign: "left" }}
                                          >
                                            <span className="text-orange-600 text-m mr-2">{expandedDates.includes(date) ? "-": "+"}</span>
                                            <span className="text-orange-600 text-m">{formatDate(date)}</span>
                                          </div>
                                          {expandedDates.includes(date) && (
                                            <div className="text-sm">
                                              {logs.map((log, index) => (
                                                <div key={index} className="flex justify-start">
                                                  <div className="flex-[25%] border border-white mr-0.5 p-1">{formatDateTime(log.dateRead)}</div>
                                                  <div className="flex-[30%] border border-white mr-0.5 p-1">{log.readingRemarks}</div>
                                                  <div className="flex-[18%] border border-white mr-0.5 p-1">{log.readerName}</div>
                                                  <div className="flex-[12%] border border-white p-1">{formatReadTime(log.readTimeInMiliseconds)}</div>
                                                  <div className="flex-[10%] border border-white p-1 flex items-center">
                                                    <Tooltip text={"Add Comment/Notes"} position={"top"}>
                                                      <span
                                                        className="mx-1 text-blue-500 cursor-pointer"
                                                        onClick={() =>
                                                          postComment(
                                                            book.bookId,
                                                            book.bookTitle,
                                                            book.ownerId,
                                                            log.pageNumber
                                                          )
                                                        }
                                                      >
                                                        <i className="fa-solid fa-edit"></i>
                                                      </span>
                                                    </Tooltip>
                                                    <Tooltip text={"View Notes/ Comment"} position={"top"}>
                                                      <span
                                                        className="mx-1 text-blue-500 cursor-pointer"
                                                        onClick={() =>
                                                          readComment(book.bookId, book.ownerId, log.pageNumber)
                                                        }
                                                      >
                                                        <i className="fa-solid fa-comments"></i>
                                                      </span>
                                                    </Tooltip>
                                                  </div>
                                                  <div className="flex-[5%] border border-white p-1 flex items-center">
                                                    <Tooltip text={"RCA"} position={"top"}>
                                                      <span
                                                        className="mx-1 text-blue-500 cursor-pointer"
                                                        onClick={() =>
                                                          gotoRCA(
                                                            book.bookId,
                                                            book.bookTitle,
                                                            book.ownerId,
                                                            log.pageNumber
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon icon={faFish} />
                                                      </span>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      )
                                    )}
                                  </div>
                                  {postCommentClicked && !postCloseClicked && (
                                    <>
                                      <div
                                        className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                                        style={{ zIndex: 1000 }}
                                      >
                                        <div className="flex flex-col justify-between bg-black text-white border-b border-b-gray-300 mr-4 ml-4 p-4">
                                          <p>Notes/Remarks Title*: </p>
                                          <input
                                            className="text-white ml-4 bg-slate-600 mb-2 w-full p-2"
                                            style={{ width: "90%" }}
                                            value={userCommentTitle}
                                            onChange={(e) =>
                                              setUserCommentTitle(
                                                e.target.value
                                              )
                                            }
                                            placeholder="Input title"
                                          />
                                          <p>Notes/Remarks Details*: </p>
                                          <textarea
                                            className="text-white ml-4 bg-slate-600 mb-2 w-full p-2"
                                            style={{
                                              height: "250px",
                                              width: "90%",
                                            }}
                                            value={userCommentDetails}
                                            onChange={(e) =>
                                              setUserCommentDetails(
                                                e.target.value
                                              )
                                            }
                                            placeholder="Input your notes/comment/remarks"
                                          />
                                          <label
                                            htmlFor="important"
                                            className="text-sm text-white"
                                          >
                                            <input
                                              type="checkbox"
                                              id="important"
                                              checked={isImportantChecked}
                                              onChange={
                                                handleImportantCheckboxChange
                                              }
                                              className="mr-2"
                                            />
                                            Is Important
                                          </label>
                                          <label
                                            htmlFor="visibleToAll"
                                            className="text-sm text-white"
                                          >
                                            <input
                                              type="checkbox"
                                              id="visibleToAll"
                                              checked={isVisibleToAllChecked}
                                              onChange={
                                                handleVisibleToAllCheckboxChange
                                              }
                                              className="mr-2"
                                            />
                                            Visible to All
                                          </label>
                                          <div className="ml-4 mr-r mt-4 mb-4 flex flex-row">
                                            <button
                                              className="bg-purple-700"
                                              onClick={() =>
                                                handlePostComment(
                                                  userCommentTitle,
                                                  userCommentDetails,
                                                  isImportantChecked,
                                                  isVisibleToAllChecked,
                                                  currentPageNumber,
                                                  book.bookId,
                                                  book.bookTitle,
                                                  book.ownerId
                                                )
                                              }
                                              disabled={postToBeDisabled}
                                              style={{ maxWidth: "150px" }}
                                            >
                                              Post
                                            </button>
                                            <button
                                              className="bg-purple-700 ml-4"
                                              style={{ maxWidth: "150px" }}
                                              onClick={handlePostClose}
                                            >
                                              Close
                                            </button>
                                          </div>
                                          {errors && (
                                            <p className="text-red-600">
                                              {errors}
                                            </p>
                                          )}
                                          {postedCommentMsg && (
                                            <p>{postedCommentMsg}</p>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {readCommentClicked &&
                                    !readCommentCloseClicked && (
                                      <div
                                        className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                                        style={{ zIndex: 1000 }}
                                      >
                                        <div className="bg-black p-4 text-white rounded-md shadow-md w-7/12 max-w-4xl max-h-screen overflow-y-auto">
                                          <div className="flex justify-center text-blue-800 text-m border-b">
                                            <p>
                                              {sortedCommentData.length}{" "}
                                              Comments/Notes on Page#{" "}
                                              {currentPageNumber} for the book{" "}
                                              {bookTitle}
                                            </p>
                                          </div>
                                          {sortedCommentData.length > 0 ? (
                                            sortedCommentData.map(
                                              (commentItem, commentIndex) => (
                                                <div
                                                  key={commentIndex}
                                                  className="mb-4 p-4 border-b border-gray-300"
                                                >
                                                  <p>
                                                    <strong>
                                                      Comment/Note By:
                                                    </strong>{" "}
                                                    {commentItem.notesBy}
                                                  </p>
                                                  <p>
                                                    <strong>
                                                      Comment/Note Title:
                                                    </strong>{" "}
                                                    {commentItem.notesTitle}
                                                  </p>
                                                  <p>
                                                    <strong>
                                                      Comment/Note Details:
                                                    </strong>{" "}
                                                    {commentItem.notesText}
                                                  </p>
                                                  <p>
                                                    <strong>
                                                      Is Important:
                                                    </strong>{" "}
                                                    {commentItem.isImportant
                                                      ? "Yes"
                                                      : "No"}
                                                  </p>
                                                  <p>
                                                    <strong>Date:</strong>{" "}
                                                    {formatDateTime(
                                                      commentItem.dateCreated
                                                    )}
                                                  </p>
                                                </div>
                                              )
                                            )
                                          ) : (
                                            <div className="mt-20 mb-20 flex justify-center text-blue-600 text-lg">
                                              <p className="text-orange-500">
                                                There are no Notes / Comments /
                                                Remarks for this Page!!
                                              </p>
                                            </div>
                                          )}
                                          <div className="mt-4 text-center">
                                            <button
                                              className="bg-purple-700 text-white py-2 px-4 rounded"
                                              style={{ maxWidth: "150px" }}
                                              onClick={handleReadCommentClose}
                                            >
                                              Close
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </>
                              )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>    
    </div>
  );
};

export default IAmFlying;
